import EntityBase from '@/data/EntityBase';

export default class RuleState extends EntityBase({
  updating: 0,
}) {}
